import { TypeEnum } from '@modules/order/models/type.enum';
import { ProcedureEnum } from '@core/procedure-helpers/models/procedure.enum';
import { IntuitiveIndication } from "@modules/rx-intuitive-teeth-orchestrator/models";

export const isDentureRemovableFullDentureImplantBased = (
	procedureId: ProcedureEnum | undefined,
	typeId: TypeEnum | undefined): boolean => {
	return procedureId === ProcedureEnum.Denture_Removable && typeId === TypeEnum.Full_Denture_implant_based;
};

export const isImplantPlanning = (procedureId: ProcedureEnum | undefined): boolean => {
	return procedureId === ProcedureEnum.ImplantPlanning
};

export const isImplantIndication = (indicationId: IntuitiveIndication): boolean => {
	return indicationId === IntuitiveIndication.ImplantBased ||
		indicationId === IntuitiveIndication.BridgeImplantBased ||
		indicationId === IntuitiveIndication.ImplantPosition;
};